import React from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useQuery } from "react-query"
import { GENERAL } from "api/general"
import { useParams } from "react-router"
import ActivityLoader from "components/activity-loader"

const DependantsBeneficiaryProfile = props => {
  //meta title
  document.title = "Beneficiary Profile"
  const params = useParams()
  const dependantBeneficiaryID = params.dependantId

  const { data: profileInfo, isLoading } = useQuery({
    queryKey: ["getBeneficiaryByBeneficiaryId", dependantBeneficiaryID],
    queryFn: () => {
      return GENERAL.getBeneficiaryByBeneficiaryId(dependantBeneficiaryID)
    },
  })

  const { data: getBeneficiaryById, isLoading: photoLoading } = useQuery({
    queryKey: ["getBeneficiaryById", dependantBeneficiaryID],
    queryFn: () => {
      return GENERAL.getBeneficiaryById(dependantBeneficiaryID)
    },
  })

  return (
    <React.Fragment>
      <div className="bg-white box-shadow-css">
        <div className="text-white ">
          <p className="bg-primary py-1 px-1 col-2 m-0 w-2">
            Dependant Beneficiary's Profile
          </p>
        </div>
        {isLoading ? (
          <center className="py-5">
            <ActivityLoader variant="primary" />
          </center>
        ) : (
          <Card>
            <Row>
              <Col lg="12">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <Row
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col lg="2" className=" mt-5">
                          <div className="d-flex text-center">
                            {photoLoading ? (
                              ""
                            ) : (
                              <div className="ms-3 text-center">
                                <img
                                  src={`data:image/jpeg;base64,${getBeneficiaryById.data?.photo}`}
                                  width={400}
                                  height={400}
                                  style={{ borderRadius: "50%" }}
                                  alt=""
                                  className="avatar-xl"
                                />
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col lg="10">
                          <div className="row row-cols-lg-5">
                            <Col className="mt-5">
                              <p className="mb-1">Application ID</p>
                              <h5>{profileInfo?.beneficiaryId ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Name of Principal</p>
                              <h5>
                                {`${
                                  profileInfo?.beneficiaryNin?.lastName ??
                                  " ----"
                                } ${
                                  profileInfo?.beneficiaryNin?.lastName ?? ""
                                }`}
                              </h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Surname</p>
                              <h5>{profileInfo?.surname ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">First Name</p>
                              <h5>{profileInfo?.firstName ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Middle Name</p>
                              <h5>
                                {profileInfo?.middleName !== ""
                                  ? profileInfo?.middleName
                                  : "---"}
                              </h5>{" "}
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Gender</p>
                              <h5>{profileInfo?.gender ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">State Of Origin</p>
                              <h5>{profileInfo?.stateOfOrigin ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Phone Number</p>
                              <h5>
                                {profileInfo?.phoneNumber !== ""
                                  ? profileInfo?.phoneNumber
                                  : "---"}
                              </h5>{" "}
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Home Address</p>
                              <h5>{profileInfo?.address ?? "---"}</h5>
                            </Col>

                            <Col className="mt-5">
                              <p className="mb-1">Beneficiary Category</p>
                              <h5>{profileInfo?.category ?? "---"}</h5>
                            </Col>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Col>
            </Row>
          </Card>
        )}
      </div>
    </React.Fragment>
  )
}

export default DependantsBeneficiaryProfile
